var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSlackLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_442_745)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.4163 62.9923C21.4163 68.7404 16.7706 73.386 11.0226 73.386C5.27458 73.386 0.628906 68.7404 0.628906 62.9923C0.628906 57.2443 5.27458 52.5986 11.0226 52.5986H21.4163V62.9923ZM26.6132 62.9923C26.6132 57.2443 31.2588 52.5986 37.0069 52.5986C42.7549 52.5986 47.4006 57.2443 47.4006 62.9923V88.9766C47.4006 94.7246 42.7549 99.3703 37.0069 99.3703C31.2588 99.3703 26.6132 94.7246 26.6132 88.9766V62.9923Z",
    fill: "#E01E5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0075 21.2601C31.2594 21.2601 26.6138 16.6144 26.6138 10.8664C26.6138 5.11833 31.2594 0.472656 37.0075 0.472656C42.7555 0.472656 47.4012 5.11833 47.4012 10.8664V21.2601H37.0075ZM37.0075 26.5357C42.7555 26.5357 47.4012 31.1813 47.4012 36.9294C47.4012 42.6774 42.7555 47.3231 37.0075 47.3231H10.9445C5.19645 47.3231 0.550781 42.6774 0.550781 36.9294C0.550781 31.1813 5.19645 26.5357 10.9445 26.5357H37.0075Z",
    fill: "#36C5F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.66 36.9294C78.66 31.1813 83.3057 26.5357 89.0537 26.5357C94.8018 26.5357 99.4474 31.1813 99.4474 36.9294C99.4474 42.6774 94.8018 47.3231 89.0537 47.3231H78.66V36.9294ZM73.4632 36.9294C73.4632 42.6774 68.8175 47.3231 63.0695 47.3231C57.3214 47.3231 52.6758 42.6774 52.6758 36.9294V10.8664C52.6758 5.11833 57.3214 0.472656 63.0695 0.472656C68.8175 0.472656 73.4632 5.11833 73.4632 10.8664V36.9294Z",
    fill: "#2EB67D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0695 78.5829C68.8175 78.5829 73.4632 83.2285 73.4632 88.9766C73.4632 94.7246 68.8175 99.3703 63.0695 99.3703C57.3214 99.3703 52.6758 94.7246 52.6758 88.9766V78.5829H63.0695ZM63.0695 73.386C57.3214 73.386 52.6758 68.7404 52.6758 62.9923C52.6758 57.2443 57.3214 52.5986 63.0695 52.5986H89.1325C94.8805 52.5986 99.5262 57.2443 99.5262 62.9923C99.5262 68.7404 94.8805 73.386 89.1325 73.386H63.0695Z",
    fill: "#ECB22E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_442_745"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlackLogo);
export default __webpack_public_path__ + "static/media/Slack-logo.ffeb05bb4bb837d829415d619509a8e4.svg";
export { ForwardRef as ReactComponent };